<template>
  <div class="input-group message">
    <span class="input-group-btn" style="white-space: normal">
      <chat-emoji :pickerWidth="'#' + group.uuid + '-new-message'" @emoji-picked="emojiPicked($event)"></chat-emoji>
    </span>
    <textarea
      type="text"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @keyup.enter="$emit('send-message')"
      @keypress="preventNewLine($event)"
      class="send-message-src form-control"
      :placeholder="placeholder"
    />
    <span class="input-group-btn">
      <button
        type="button"
        class="btn btn-default btn-chat"
        @click="$emit('send-message')"
        aria-label="Left Align"
        :disabled="!canSendMessage"
      >
        <i
          class="ar-icon icon-comment-alt-light"
          :class="canSendMessage ? 'user_in' : 'user_out'"
          aria-hidden="true"
        ></i>
      </button>
    </span>
  </div>
</template>

<script>
import ChatMixin from "@/components/DigitalEvent/RoomList/Room/mixins/ChatMixin";

export default {
  name: "ChatInput",
  mixins: [ChatMixin],
  components: {
    "chat-emoji": () => import("./ChatEmoji.vue")
  },
  props: {
    group: Object,
    placeholder: String,
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    canSendMessage() {
      return this.value.trim();
    }
  },
  methods: {
    preventNewLine(event) {
      if (event.keyCode == 13) {
        event.preventDefault();
      }
    },
    emojiPicked(event) {
      let textarea = document.querySelector(".send-message-src");
      textarea.focus();
      this.$emit("emoji-picked", event);
    }
  }
};
</script>

<style></style>
